import { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { complainReplyActions } from '../store/complainReplySlice';
import { complaintViewActions } from '../store/complaintViewSlice';
import { LuMessageSquare, LuReply, LuArrowLeft, LuArrowRight, LuX, LuCheck } from "react-icons/lu";
import { set } from 'date-fns';
import { useGetComplaintByIdQuery } from '../store/services/complaintsServices';
import { CircularProgress } from '@mui/material';

const customStyles = {
    content: {
        position: 'static',
        borderRadius: '10px',
        padding: 0,
        maxWidth: 'calc(100vw - 2rem)',
    },
    overlay: {
        background: 'rgba(0, 0, 0, 0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }
};

Modal.setAppElement(document.getElementById('root'))

const ReplyView = ({ reply = { title: '', body: '' }, handleCloseModal }) => {
    return (
        <div>
            <div className='mb-4 sm:mb-8 font-bold text-base sm:text-lg text-center'>Përgjigja e ankesës</div>
            <div className='flex flex-col gap-4 w-full'>
                <div className='flex flex-col gap-1'>
                    <span className='font-semibold text-sm'>Titulli:</span>
                    <input
                        type='text'
                        className='p-3 disabled:bg-neutral-100 w-full rounded-lg text-sm'
                        value={reply.title}
                        disabled
                    />
                </div>
                <div className='flex flex-col gap-1'>
                    <span className='font-semibold text-sm'>Përshkrimi:</span>
                    <textarea
                        type='text'
                        className='p-3 h-40 w-full rounded-lg disabled:bg-neutral-100 text-sm resize-none'
                        value={reply.body}
                        disabled
                    />
                </div>
                <div className='flex justify-between items-center text-sm font-semibold'>
                    <div className="flex items-center justify-center w-full sm:w-auto gap-2 p-2 px-6 rounded-xl cursor-pointer bg-primary/5 hover:bg-gray-100"
                        onClick={handleCloseModal}>
                        <span><LuArrowLeft size={18} /></span>
                        <span>Back</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default function ComplaintView() {

    const initialData = useSelector(state => state.complaint_view.data)
    const dispatch = useDispatch()
    const isOpen = useSelector(state => state.complaint_view.isOpen)

    const [title, setTitle] = useState('')
    const [body, setBody] = useState('')
    const [userDetailsExpanded, setUserDetailsExpanded] = useState(true)
    const [complainDetailsExpanded, setComplainDetailsExpanded] = useState(true)
    const { data: complaintData, isLoading, isFetching } = useGetComplaintByIdQuery(
        initialData?.complaint_id || '',
    );

    const data = complaintData?.data;

    console.log({ data })

    const [isReplyView, setIsReplyView] = useState(false)

    function closeModal() {
        dispatch(complaintViewActions.closeModal())
        setIsReplyView(false)
    }

    const handleCancel = () => {
        dispatch(complaintViewActions.closeModal())
        setIsReplyView(false)
    }

    const handleReplyClick = () => {
        dispatch(complainReplyActions.openModal(data))
        closeModal();
        setIsReplyView(false)
    }

    useEffect(() => {
        console.log({ isFetching })
    }, [isFetching])

    return (
        <div>
            <Modal
                isOpen={isOpen}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <div className="bg-white p-4 sm:p-5 max-h-[90dvh] w-[480px] max-w-full overflow-y-scroll no-scrollbar relative break-words">
                    {(isLoading || isFetching) && (
                        <div className='absolute inset-0 bg-white flex items-center justify-center z-10'>
                            <CircularProgress />
                        </div>
                    )}
                    {isReplyView ? <ReplyView handleCloseModal={() => setIsReplyView(false)} reply={{ title: data?.reply_title, body: data?.reply_body }} /> : (
                        <div className=''>
                            <div className='mb-4 sm:mb-8 font-bold text-base sm:text-lg text-center'>Detajet e ankesës</div>
                            <div className='flex flex-col gap-4 w-full'>
                                <div className='text-sm flex flex-col gap-2'>
                                    <div><span className='font-bold'>🔹 Tipi i ankesës</span>: {data?.complaint_type}</div>
                                    <div className='hover:underline cursor-pointer' onClick={() => setUserDetailsExpanded(!userDetailsExpanded)}><span className='font-semibold'>🔹 Të dhënat e qytetarit</span></div>
                                    <div className={`${userDetailsExpanded ? 'max-h-full p-2' : 'max-h-0 overflow-hidden hidden'} rounded-md flex flex-col gap-1`}>
                                        <div><span className='font-semibold'>• &nbsp;&nbsp;ID: </span>{data?.complaint_user_id}</div>
                                        <div><span className='font-semibold'>• &nbsp;&nbsp;Emri dhe mbiemri: </span>{data?.complaint_user_fullname}</div>
                                        <div><span className='font-semibold'>• &nbsp;&nbsp;Email: </span>{data?.complaint_user_email}</div>
                                    </div>
                                    {data?.receipt_id && (
                                        <>
                                            <div className='font-bold cursor-pointer hover:underline' onClick={() => setComplainDetailsExpanded(!complainDetailsExpanded)}>🔹 Detajet e kuponit</div>
                                            <div className={`${complainDetailsExpanded ? 'max-h-full p-2' : 'max-h-0 overflow-hidden'} rounded-md flex flex-col gap-1`}>
                                                <div><span className='font-semibold'>• &nbsp;&nbsp;NUI: </span>{data?.NUI}</div>
                                                <div><span className='font-semibold'>• &nbsp;&nbsp;Numri i kuponit: </span>{data?.coupon_id}</div>
                                                <div><span className='font-semibold'>• &nbsp;&nbsp;Emri i biznesit: </span>{data?.business_name}</div>
                                            </div>
                                        </>
                                    )
                                    }
                                    {data?.game_title && (
                                        <div className='flex flex-col gap-1 text-sm'>
                                            <div className='font-bold cursor-pointer hover:underline' onClick={() => setComplainDetailsExpanded(!complainDetailsExpanded)}>🔹 Detajet e lojës</div>
                                            <div className={`${complainDetailsExpanded ? 'max-h-full p-2 ' : 'max-h-0 overflow-hidden'} rounded-md flex flex-col gap-1`}>
                                                <div><span className='font-semibold'>• &nbsp;&nbsp;Loja: </span>{data?.game_title}</div>
                                                <div><span className='font-semibold'>• &nbsp;&nbsp;Tipi i lojës: </span>{data?.game_type}</div>
                                            </div>
                                        </div>
                                    )
                                    }
                                </div>
                                <div className='flex flex-col gap-2'>
                                    <div className='font-bold text-sm'>🔹 Detajet e ankesës</div>
                                    <div className='p-2 flex flex-col gap-2'>
                                        <div className='flex flex-col gap-1'>
                                            <span className='font-semibold text-sm'>• &nbsp;&nbsp;Data e dorëzimit të ankesës: <span className='font-normal'>{data?.created_at}</span></span>
                                        </div>
                                        <div className='flex flex-col gap-1'>
                                            <span className='font-semibold text-sm'>• &nbsp;&nbsp;Titulli i ankesës: <span className='font-normal'>{data?.complaint_title}</span></span>
                                        </div>
                                        <div className='flex flex-col gap-1'>
                                            <span className='font-semibold text-sm'>• &nbsp;&nbsp;Përshkrimi i dhënë nga qytetari:</span>
                                            <div className='flex'>
                                                <div className='text-sm ml-2 sm:ml-4 whitespace-pre-wrap'>
                                                    {data?.complaint_body}
                                                </div>
                                                {/* <textarea
                                                type='text'
                                                placeholder='Body'
                                                className='max-h-48 bg-white w-full text-sm resize-none'
                                                value={data?.complaint_body}
                                                disabled
                                            /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {data?.isReplied === 1 && (
                                    <div className='flex flex-col gap-2'>
                                        <div className='font-semibold text-sm'>🔹 Përgjigja për qytetarin</div>
                                        <div className='p-2 flex flex-col gap-2'>
                                            <div className='flex flex-col gap-1'>
                                                <span className='font-semibold text-sm'>• &nbsp;&nbsp;Data dhe ora: <span className='font-normal'>{data?.replied_at}</span></span>
                                            </div>
                                            <div className='flex flex-col gap-1'>
                                                <span className='font-semibold text-sm'>• &nbsp;&nbsp;Zyrtari që ktheu përgjigjen: <span className='font-normal'>{data?.reply_user_fullname}</span></span>
                                            </div>
                                            <div className='flex flex-col gap-1'>
                                                <span className='font-semibold text-sm'>• &nbsp;&nbsp;Titulli i përgjigjes: <span className='font-normal'>{data?.reply_title}</span></span>
                                            </div>
                                            <div className='flex flex-col gap-1'>
                                                <span className='font-semibold text-sm'>• &nbsp;&nbsp;Teksti i përgjigjes:</span>
                                                <div className='flex gap-2'>
                                                    <div className='text-sm ml-2 sm:ml-4 whitespace-pre-wrap'>{data?.reply_body}</div>
                                                    {/* <textarea
                                                        type='text'
                                                        placeholder='Body'
                                                        className='max-h-48 bg-white w-full text-sm resize-none'
                                                        value={data?.complaint_body}
                                                        disabled
                                                    /> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {!data?.isReplied && (
                                    <div className="flex justify-end mt-2 text-sm font-semibold">
                                        {/* <div className="flex items-center gap-2 p-2 px-6 rounded-xl cursor-pointer bg-primary/5 hover:bg-gray-100"
                                        onClick={handleCancel}>
                                        <span><LuX size={18} /></span>
                                        <span>Close</span>
                                    </div> */}
                                        <div className="p-2 px-6 bg-secondary text-white w-full justify-center rounded-xl cursor-pointer flex items-center gap-2 hover:bg-secondary/80"
                                            onClick={handleReplyClick}
                                        >
                                            <span><LuReply size={18} /></span>
                                            <span>Kthe përgjigjen</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </Modal>
        </div>)
}